// Solid symbol set for the "Simgeler" category (Font Awesome 6 Free, CC BY 4.0,
// through react-icons). Keyed by the catalog's `icon` field.
import {
  FaBookOpen,
  FaGraduationCap,
  FaSchool,
  FaChalkboardUser,
  FaUserGraduate,
  FaLightbulb,
  FaBrain,
  FaBullseye,
  FaCircleCheck,
  FaCircleXmark,
  FaTriangleExclamation,
  FaCircleInfo,
  FaCircleQuestion,
  FaWandMagicSparkles,
  FaCirclePlay,
  FaCirclePause,
  FaVolumeHigh,
  FaHeadphones,
  FaVideo,
  FaImage,
  FaFileLines,
  FaFolderOpen,
  FaClipboardList,
  FaListCheck,
  FaPen,
  FaPenToSquare,
  FaCalendarDays,
  FaClock,
  FaHourglassHalf,
  FaTrophy,
  FaMedal,
  FaAward,
  FaFlag,
  FaRocket,
  FaPuzzlePiece,
  FaGear,
  FaMagnifyingGlass,
  FaChartLine,
  FaChartPie,
  FaUsers,
  FaUser,
  FaComments,
  FaEnvelope,
  FaPhone,
  FaLaptop,
  FaMobileScreen,
  FaGlobe,
  FaLock,
  FaKey,
  FaShieldHalved,
  FaHandshake,
  FaThumbsUp,
} from "react-icons/fa6";

export const ICONS = {
  book: FaBookOpen,
  graduation: FaGraduationCap,
  school: FaSchool,
  teacher: FaChalkboardUser,
  student: FaUserGraduate,
  idea: FaLightbulb,
  brain: FaBrain,
  target: FaBullseye,
  correct: FaCircleCheck,
  wrong: FaCircleXmark,
  warning: FaTriangleExclamation,
  info: FaCircleInfo,
  question: FaCircleQuestion,
  hint: FaWandMagicSparkles,
  play: FaCirclePlay,
  pause: FaCirclePause,
  sound: FaVolumeHigh,
  headphones: FaHeadphones,
  video: FaVideo,
  image: FaImage,
  document: FaFileLines,
  folder: FaFolderOpen,
  clipboard: FaClipboardList,
  checklist: FaListCheck,
  pen: FaPen,
  edit: FaPenToSquare,
  calendar: FaCalendarDays,
  clock: FaClock,
  hourglass: FaHourglassHalf,
  trophy: FaTrophy,
  medal: FaMedal,
  award: FaAward,
  flag: FaFlag,
  rocket: FaRocket,
  puzzle: FaPuzzlePiece,
  gear: FaGear,
  search: FaMagnifyingGlass,
  chartLine: FaChartLine,
  chartPie: FaChartPie,
  team: FaUsers,
  person: FaUser,
  chat: FaComments,
  mail: FaEnvelope,
  phone: FaPhone,
  laptop: FaLaptop,
  mobile: FaMobileScreen,
  globe: FaGlobe,
  lock: FaLock,
  key: FaKey,
  shield: FaShieldHalved,
  handshake: FaHandshake,
  like: FaThumbsUp,
};
